module.exports = __webpack_public_path__ + "img/faster_option_pb1.e63c55f8.svg";